import { Component, ContentChild, ContentChildren, EventEmitter, forwardRef, Input, Output, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_SELECT_CONFIG, MatSelect, MatSelectChange } from '@angular/material/select';
import { BaseViewComponent } from '@sb/library/base';
import { ChipButtonSelectItemComponent } from './item/chip-button-select-item.component';
import { ChipButtonSelectBottomSheetComponent } from './select-bottom-sheet/chip-button-select-bottom-sheet.component';

@Component({
    selector: 'lib-chip-button-select',
    templateUrl: './chip-button-select.component.html',
    styleUrls: ['./chip-button-select.component.scss'],
    viewProviders: [
        {
            provide: MAT_SELECT_CONFIG,
            useFactory: (component: ChipButtonSelectComponent<any>) => ({
                overlayPanelClass:  ["v3", "scss-chip-select-panel"],
                panelWidth: component.panelWidth
            }),
            // need to inject MAT_SELECT_CONFIG here, and need to be able to access the input before its defined
            deps: [forwardRef(() => ChipButtonSelectComponent)]
        }
    ]
})

export class ChipButtonSelectComponent<T> extends BaseViewComponent {
    @ViewChild('chipSelect', {static: true}) select!: MatSelect;

    @ContentChildren(ChipButtonSelectItemComponent) chipOptions!: QueryList<ChipButtonSelectItemComponent<T>>;
    @ContentChild(TemplateRef, {static: false}) triggerTemplate!: TemplateRef<any>;
    @ContentChild(TemplateRef, {static: false}) prefixIcon!: TemplateRef<T>;

    private _currentSelection!: T;
    @Input()
    set currentSelection(value: T) {
        this._currentSelection = value;
        if (this.chipOptions) {
            this.SetUpChipSelect();
        }
    }

    @Input() disableBottomSheet: boolean = false;
    @Input() stretch: boolean = false;
    @Input() disableBorder: boolean = false;
    @Input() loading: boolean = false;
    @Input() panelWidth: string | number | null = 320;
    @Input() qaTag: string = '';

    @Output() selectionChange: EventEmitter<T> = new EventEmitter();

    private _options!: ChipButtonSelectItemComponent<T>[];
    private _selected!: ChipButtonSelectItemComponent<T>;

    constructor(private _MatBottomSheet: MatBottomSheet) {
        super();
    }

    ngAfterViewInit() {
        this.SetUpChipSelect();
    }

    SetUpChipSelect(): void {
        this._options = this.chipOptions.toArray();
        if (this.currentSelection) {
            this.FindSelection(this.currentSelection);
        } else {
            this._selected = this._options[0];
        }
    }

    SelectionChange(event: MatSelectChange) {
        this.FindSelection(event.value);
        this.selectionChange.emit(event.value);
    }

    OpenBottomSheet(): void {
        const bottomSheetRef = this._MatBottomSheet.open(ChipButtonSelectBottomSheetComponent, {
            data: this.chipOptions,
            hasBackdrop: true,
        });

        bottomSheetRef.afterDismissed().subscribe((selectedOption: ChipButtonSelectItemComponent<T>) => {
            if (selectedOption) {
                this._selected = selectedOption;
                this.selectionChange.emit(selectedOption.value);
            }
        });
    }

    FindSelection(value: T): void {
        if (this._options) {
            this._selected = this._options.find(chip => chip.value == value)!;
        }
    }

    get selected(): ChipButtonSelectItemComponent<T> {
        return this._selected;
    }

    get currentSelection(): T {
        return this._currentSelection;
    }
}
